import { useEffect, useRef, useState } from "react"

export const useElementOnScreen = (options) => {
    const containerRef = useRef(null)
    // Having the default state be false was causing a placement flicker on initial render 
    const [isVisible, setIsVisible] = useState(true)

    const callback = (entries) => {
        const [entry] = entries
        setIsVisible(entry.isIntersecting)
    }

    useEffect(() => {
        const observer = new IntersectionObserver(callback, options)
        if (containerRef.current) observer.observe(containerRef.current)
        return () => {
            if (containerRef.current) observer.unobserve(containerRef.current)
        }

    }, [containerRef, options])

    return [containerRef, isVisible]
}
